// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"2f33a1a8","601":"e2245b6f","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};